import * as React from 'react'
import { connect } from 'react-redux'
import { NodeApi, Tree } from 'react-arborist';
import { AppState } from '../store'
import { showArticleCollectionModal, showArticleModal, showConfirmModal, showHelpCenterModal } from '../store/modals/actions'
import ScrollToTopOnMount from '../components/Effects/ScrollToTopOnMount'
import PageLoader from '../components/Page/PageLoader'
import { Helmet } from 'react-helmet';
import { withTranslation, WithTranslation } from 'react-i18next';
import { RouteComponentProps } from 'react-router';
import { Article, ArticleCollection, BrowserSize, CurrentUser, FeaturedArticle, HelpCenterLink, PublicLocale, HelpCenterPage, HelpCenter as HelpCenterType, MimeTypes, HelpCenterTreeData, HelpCenterTreeModelType, } from '../types';
import TopNavigation from '../components/Navigation/TopNavigation';
import FullPageContent from '../components/Page/FullPageContent'
import styled, { css } from 'styled-components'
import { Style } from '../styles'
import PowerSelect from '../components/Form/PowerSelect'
import Item from '../components/HelpCenter/Item'
import ResizeObserver from '../components/ResizeObserver/ResizeObserver';
import Button from '../components/Button/Button';
import { ArticleCollectionsController, FeaturedArticlesController, HelpCentersController } from '../controllers';
import CardEmptyInfo from '../components/Card/CardEmptyInfo';
import Card from '../components/Card/Card';
import HelpCenterHelper from '../helpers/HelpCenterHelper';
import ArticlesController from '../controllers/ArticlesController';
import IconButton from '../components/Button/IconButton';
import Breadcrumb from '../components/Breadcrumb/Breadcrumb';
import ButtonGroup from '../components/Button/ButtonGroup';
import Accordion from '../components/Accordion/Accordion';
import copy from 'copy-to-clipboard';
import Notification from '../utilities/Notification';
import Utils from '../utilities/Utils';
import Tooltip from '../components/Tooltips/Tooltip';
import FaviconUpload from '../components/Form/FaviconUploader';
import { Blob } from '@rails/activestorage';
import AttachmentUploader from '../components/Form/AttachmentUploader';
import SwatchPicker from '../components/Swatch/SwatchPicker';
import CheckboxInput from '../components/Form/CheckboxInput';
import { HELP_CENTER_HERO_IMAGE_FILE_SIZE, HELPCENTER_LOGO_FILE_SIZE, HELPCENTER_OPEN_GRAPH_IMAGE_FILE_SIZE } from '../Constants';
import LinksBuilder from '../components/Form/LinksBuilder';
import MobilityHelper from '../helpers/MobilityHelper';
import { DragDropContext, Draggable, Droppable, DropResult, ResponderProvided } from '@hello-pangea/dnd';
import DroppableHelper from '../helpers/DroppableHelper';
import AccordionContainer from '../components/Accordion/AccordionContainer';
import SimpleTooltip from '@/components/Tooltips/SimpleTooltip'

const Container = styled.div`
 position: relative;
	display: flex;
	flex-direction: row;
	height: 100%;
	position: relative;

  @media screen and (max-width: ${Style.breakpoints.SMALL}) {
    flex-direction: column-reverse;
  }
`

const PageLoaderContainer = styled.div`
  flex: 1;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`

const Content = styled.div`
  padding: 0 ${Style.spacing.x2};
  flex: 1;
  overflow: auto;
  border-right: 1px solid ${Style.color.border};

  @media screen and (max-width: ${Style.breakpoints.SMALL}) {
    border-right: none;
    height: calc(50% - 106px);
  }
`

const Table = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  border: 1px solid ${Style.color.border};
  border-radius: ${Style.variables.baseBorderRadius};
  overflow: hidden;

  @media screen and (max-width: ${Style.breakpoints.SMALL}) {
    height: 30vh;
  }
`

const TableHeading = styled.div`
  padding: 8px 16px;
  text-align: left;
  font-weight: 800;
  background: #f7f7fa;
  border-bottom: 1px solid ${Style.color.border};
`

const TableHeader = styled.div`
  display: flex;
  flex-direction: row;
  border-top-left-radius: ${Style.variables.baseBorderRadius};
  border-top-right-radius: ${Style.variables.baseBorderRadius};

  ${TableHeading} {
    &:first-child {
      flex: 1;
      flex-grow: 1;
    }
  }
`

const TableActions = styled(TableHeading)`
  width: 32px;
  max-width: 32px;
`

const TableRows = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow: auto;
`

const Preview = styled.div`
  padding: 0 ${Style.spacing.x2};
  flex: 1;
  overflow: auto;

  @media screen and (max-width: ${Style.breakpoints.SMALL}) {
    height: calc(50% - 106px);
    border-bottom: 1px solid ${Style.color.border};
  }
`

const Header = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-top: ${Style.spacing.x3};
  padding-bottom: ${Style.spacing.x2};
  justify-content: space-between;
`

const BrowserPreview = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
`

const BrowserUrl = styled.div`
  display: block;
  padding: 3px 40px;
  text-align: center;
  border: 1px solid ${Style.color.border};
  border-radius: 30px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  background: white;
  max-width: 325px; 

  @media screen and (max-width: ${Style.breakpoints.SMALL}) {
    max-width: initial;
  }
`

const BrowserContainer = styled.div<{ size?: 'mobile' | 'tablet' | 'desktop' }>`
  width: 100%;
  position: relative;

  ${props => props.size === BrowserSize.MOBILE && css`
    max-width: 290px;

    ${BrowserUrl} {
      padding-left: 10px;
      padding-right: 10px;
    }

    ${BrowserHeader} {
      &:after {
        display: none;
      }
    }
  `}

  ${props => props.size === BrowserSize.TABLET && css`
    max-width: 380px;

    ${BrowserUrl} {
      padding-left: 10px;
      padding-right: 10px;
    }

    ${BrowserHeader} {
      &:after {
        display: none;
      }
    }
  `}

  ${props => props.size === BrowserSize.DESKTOP && css`
  `}
`

const Browser = styled.div`
  border-radius: 8px;
  border: 1px solid ${Style.color.border};
  width: 100%;
  display: flex;
  flex-direction: column;
  height: 75vh;
  overflow: hidden;
  border-radius: 4px; 

  @media screen and (max-width: ${Style.breakpoints.SMALL}) {
    height: 30vh;
  }
`


const BrowserHeader = styled.div`
  position: relative;
  padding: 5px;
  width: 100%;
  color: #646462;
  font-size: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid ${Style.color.border};
  background: #f7f7fa;
  cursor: pointer;

  &:after {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 10px;
    font-size: 25px;
    line-height: 25px;
    color: #8080804f;
    content: '• • •';

    @media screen and (max-width: ${Style.breakpoints.SMALL}) {
      display: none;
    }
  }

  &:hover {
    ${BrowserUrl} {
      color: ${Style.color.brandPrimary};
    }
  }
`


const BrowserContentContainer = styled.div`
  position: absolute;
  transform-origin: top;
`

const BrowserContent = styled.iframe`
  width: 100%;
  height: 100%;
  border: none;
  outline: none;
  border-radius: 0 0 8px 8px;
`

const HeaderActions = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`

const SwatchPickerContainer = styled.div`
  width: 38px;
  height: 38px;
  border: 1px solid ${Style.color.border};
  border-radius: ${Style.variables.baseBorderRadius};
  overflow: hidden;
`

const FeaturedArticlesContainer = styled.div`
  display: flex; 
  flex-direction: column;
  margin-bottom: ${Style.spacing.x2};
`

const FeaturedArticlesHeader = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: 8px;
  padding-bottom: 4px;
`

const FeaturedArticlesHeaderLabel = styled.div`
  flex-grow: 1;
  font-weight: bold;
  font-size: 14px;
  color: #646462;
`

const FeaturedArticles = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 8px;
`

const FeaturedArticleContainer = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: 8px;
  font-weight: normal !important;

  input {
    font-weight: normal !important;
  }
`

const FeaturedArticleHandle = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`

const FeaturedArticleRemove = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 38px;
  height: 38px;
  border-radius: 50%;
  cursor: pointer;

  background: #f8f8f7;
  color: #81817e;
  fill: #81817e;

  svg {
    width: 16px;
    height: 16px;
  }
`

interface IStateToProps {
  currentUser: CurrentUser
}

interface IDispatchToProps {
  showHelpCenterModal: typeof showHelpCenterModal
  showArticleCollectionModal: typeof showArticleCollectionModal
  showArticleModal: typeof showArticleModal
  showConfirmModal: typeof showConfirmModal
}

type IProps = IStateToProps & IDispatchToProps & WithTranslation & RouteComponentProps<{ id: string }>

const enum HelpCenterViewMode {
  CONTENT = 'content',
  SETTINGS = 'settings',
}

const enum HelpCenterSubviewMode {
  GENERAL = 'general',
  STYLING = 'styling',
}

interface IState {
  viewMode: HelpCenterViewMode
  subviewMode: HelpCenterSubviewMode,
  helpCenter: HelpCenterType,
  articleCollections: ArticleCollection[],
  articles: Article[],
  featuredArticles: FeaturedArticle[],
  didInitialLoad: boolean,
  selectedLocale: PublicLocale,
  selectedPage: HelpCenterPage,
  browserSize: BrowserSize
  treeData: HelpCenterTreeData[]
  editLocale: PublicLocale
}

class HelpCenter extends React.Component<IProps, IState> {
  constructor(props) {
    super(props);

    this.state = {
      viewMode: HelpCenterViewMode.CONTENT,
      subviewMode: HelpCenterSubviewMode.GENERAL,
      helpCenter: null,
      articleCollections: [],
      articles: [],
      featuredArticles: [],
      didInitialLoad: false,
      selectedLocale: null,
      selectedPage: HelpCenterPage.HOMEPAGE,
      browserSize: BrowserSize.DESKTOP,
      treeData: [],
      editLocale: PublicLocale.EN,
    }

    this.fetchHelpCenterView = this.fetchHelpCenterView.bind(this)
    this.updateHelpCenter = this.updateHelpCenter.bind(this)
    this.updateHelpCenterDebounced = Utils.debounce(this.updateHelpCenter, 250, false)
    this.onArticleSubmit = this.onArticleSubmit.bind(this)
    this.onArticleDelete = this.onArticleDelete.bind(this)
    this.onSelectedLocaleChange = this.onSelectedLocaleChange.bind(this)
    this.onAddCollectionClick = this.onAddCollectionClick.bind(this)
    this.onArticleCollectionSubmit = this.onArticleCollectionSubmit.bind(this)
    this.onItemMove = this.onItemMove.bind(this)
    this.onItemClick = this.onItemClick.bind(this)
    this.onItemAddArticleClick = this.onItemAddArticleClick.bind(this)
    this.onItemAddCollectionClick = this.onItemAddCollectionClick.bind(this)
    this.onItemEditClick = this.onItemEditClick.bind(this)
    this.onItemDeleteClick = this.onItemDeleteClick.bind(this)
    this.onItemIconClick = this.onItemIconClick.bind(this)
    this.disableDrop = this.disableDrop.bind(this)
    this.onPageChange = this.onPageChange.bind(this)
    this.onSettingsClick = this.onSettingsClick.bind(this)
    this.onBrowserSizeChange = this.onBrowserSizeChange.bind(this)
    this.onExitSettingsClick = this.onExitSettingsClick.bind(this)
    this.onSubviewModeChange = this.onSubviewModeChange.bind(this)
    this.onHelpCenterCopyUrlClick = this.onHelpCenterCopyUrlClick.bind(this)
    this.renderGeneralSettings = this.renderGeneralSettings.bind(this)
    this.renderStylingSettings = this.renderStylingSettings.bind(this)
    this.onDefaultLocaleChange = this.onDefaultLocaleChange.bind(this)
    this.onSupportedLocalesChange = this.onSupportedLocalesChange.bind(this)
    this.onSlugChange = this.onSlugChange.bind(this)
    this.onCustomDomainChange = this.onCustomDomainChange.bind(this)
    this.onGoogleAnalyticsTrackingIdChange = this.onGoogleAnalyticsTrackingIdChange.bind(this)
    this.onFaviconChange = this.onFaviconChange.bind(this)
    this.onOpenGraphImageChange = this.onOpenGraphImageChange.bind(this)
    this.onFeaturedArticlesTitleChange = this.onFeaturedArticlesTitleChange.bind(this)
    this.onFeaturedArticlesDragEnd = this.onFeaturedArticlesDragEnd.bind(this)
    this.onRemoveFeaturedArticleClick = this.onRemoveFeaturedArticleClick.bind(this)
    this.onAddFeaturedArticle = this.onAddFeaturedArticle.bind(this)
    this.onBackgroundColorChange = this.onBackgroundColorChange.bind(this)
    this.onActionColorChange = this.onActionColorChange.bind(this)
    this.onShowArticleAuthorsChange = this.onShowArticleAuthorsChange.bind(this)
    this.onHelpCenterSettingLocaleChange = this.onHelpCenterSettingLocaleChange.bind(this)
    this.onLogoChange = this.onLogoChange.bind(this)
    this.onHeaderPageTitleChange = this.onHeaderPageTitleChange.bind(this)
    this.onHeaderLinksChange = this.onHeaderLinksChange.bind(this)
    this.onHeaderBackgroundColorChange = this.onHeaderBackgroundColorChange.bind(this)
    this.onHeaderTextColorChange = this.onHeaderTextColorChange.bind(this)
    this.onWelcomeMessageChange = this.onWelcomeMessageChange.bind(this)
    this.onHeroImageChange = this.onHeroImageChange.bind(this)
    this.onHeroBackgroundFadeChange = this.onHeroBackgroundFadeChange.bind(this)
    this.onHeroHeightChange = this.onHeroHeightChange.bind(this)
    this.onCollectionDescriptionsEnabledChange = this.onCollectionDescriptionsEnabledChange.bind(this)
    this.onTableOfContentsEnabledChange = this.onTableOfContentsEnabledChange.bind(this)
    this.onRelatedArticlesEnabledChange = this.onRelatedArticlesEnabledChange.bind(this)
    this.getPreviewUrl = this.getPreviewUrl.bind(this)
  }

  componentDidMount(): void {
    this.fetchHelpCenterView().catch(console.error)
  }

  async fetchHelpCenterView() {
    const { match: { params: { id } } } = this.props
    const { selectedLocale } = this.state

    try {
      const {
        help_center,
        article_collections,
        articles,
        featured_articles
      } = await HelpCentersController.getView(id)

      const treeData: HelpCenterTreeData[] = this.getTreeData(article_collections, articles)

      this.setState({
        helpCenter: help_center,
        articleCollections: article_collections,
        articles: articles,
        featuredArticles: featured_articles,
        selectedLocale: selectedLocale || help_center.locale as PublicLocale,
        didInitialLoad: true,
        treeData: treeData,
        editLocale: help_center.locale as PublicLocale,
      })
    } catch (ex) {
      console.error(ex)
    }
  }

  async updateHelpCenter(helpCenter: HelpCenterType) {
    try {
      const response = await HelpCentersController.update(helpCenter)

      if (!response.errors) {
        this.setState({
          helpCenter: response
        })
      }
    } catch (ex) {
      console.error(ex)
    }
  }

  updateHelpCenterDebounced(helpCenter: HelpCenterType) {
    this.updateHelpCenter(helpCenter).catch(console.error)
  }

  getTreeData(collections: ArticleCollection[], articles: Article[]) {
    // Create maps for easy lookups
    const collectionsMap = {};
    collections.forEach(collection => {
      collectionsMap[collection.id] = collection;
    });

    // Create tree nodes for each collection
    const collectionNodes = {};
    collections.forEach(collection => {
      collectionNodes[collection.id] = {
        type: HelpCenterTreeModelType.COLLECTION,
        model: collection,
        children: []
      };
    });

    // Find root-level articles (those without a collection or with invalid collection)
    const rootArticles = [];
    const articleNodes = articles.map(article => {
      const node = {
        type: HelpCenterTreeModelType.ARTICLE,
        model: article,
        children: null
      };

      const collectionId = article.collection_id;
      if (!collectionId || !collectionNodes[collectionId]) {
        rootArticles.push(node);
      }

      return node;
    });

    // Prepare collections to store child articles and collections separately
    collections.forEach(collection => {
      collectionNodes[collection.id].articleChildren = [];
      collectionNodes[collection.id].collectionChildren = [];
    });

    // Add articles to their parent collections
    articleNodes.forEach(articleNode => {
      const collectionId = articleNode.model.collection_id;
      if (collectionId && collectionNodes[collectionId]) {
        collectionNodes[collectionId].articleChildren = collectionNodes[collectionId].articleChildren || [];
        collectionNodes[collectionId].articleChildren.push(articleNode);
      }
    });

    // Build collection hierarchy
    const rootCollections = [];
    collections.forEach(collection => {
      const node = collectionNodes[collection.id];
      const parentId = collection.parent_id;

      if (!parentId || !collectionNodes[parentId]) {
        // This is a root collection
        rootCollections.push(node);
      } else {
        // Add to parent collection's collection children
        collectionNodes[parentId].collectionChildren = collectionNodes[parentId].collectionChildren || [];
        collectionNodes[parentId].collectionChildren.push(node);
      }
    });

    // Sort function by position
    const sortByPosition = (a, b) => {
      const posA = a.model.position || 0;
      const posB = b.model.position || 0;
      return posA - posB;
    };

    // Merge and sort children (articles first, then collections)
    collections.forEach(collection => {
      const node = collectionNodes[collection.id];

      // Sort article children
      if (node.articleChildren) {
        node.articleChildren.sort(sortByPosition);
      }

      // Sort collection children
      if (node.collectionChildren) {
        node.collectionChildren.sort(sortByPosition);
      }

      // Combine with articles first, then collections and lastly the "add article" node

      const sortedChildren = [
        ...(node.articleChildren || []),
        ...(node.collectionChildren || []),
      ]

      node.children = [
        ...sortedChildren,
        {
          type: HelpCenterTreeModelType.ADD_ARTICLE,
          model: {
            id: `add-article-${node.model.id}`,
            collection_id: node.model.id,
            position: HelpCenterHelper.getCreatePosition(sortedChildren.map(child => child.model)),
          },
          children: [],
        }
      ];

      // Clean up temporary properties
      delete node.articleChildren;
      delete node.collectionChildren;
    });

    // Sort root articles and collections
    rootArticles.sort(sortByPosition);
    rootCollections.sort(sortByPosition);

    // Create final result with articles first, then collections
    const rootNodes = [...rootArticles, ...rootCollections];

    return rootNodes;
  }

  onPageChange(option) {
    this.setState({ selectedPage: option.value })
  }

  onSettingsClick() {
    this.setState({
      viewMode: HelpCenterViewMode.SETTINGS,
      subviewMode: HelpCenterSubviewMode.GENERAL
    })
  }

  onBrowserSizeChange(option) {
    this.setState({ browserSize: option.value })
  }

  onExitSettingsClick(e) {
    e.preventDefault()

    this.setState({
      viewMode: HelpCenterViewMode.CONTENT,
      subviewMode: HelpCenterSubviewMode.GENERAL
    })
  }

  onSelectedLocaleChange(option) {
    this.setState({ selectedLocale: option.value, })
  }

  onAddCollectionClick() {
    const { helpCenter, selectedLocale, treeData } = this.state

    const items = treeData.map(item => item.model)

    requestAnimationFrame(() => {
      this.props.showArticleCollectionModal({
        helpCenterId: helpCenter.id,
        locale: selectedLocale,
        articleCollection: {
          position: HelpCenterHelper.getCreatePosition(items),
        },
        onSubmit: this.onArticleCollectionSubmit
      })
    })
  }

  async onItemMove(data: {
    dragIds: string[];
    dragNodes: NodeApi<HelpCenterTreeData>[];
    parentId: string | null;
    parentNode: NodeApi<HelpCenterTreeData>;
    index: number;
  }) {
    const { t } = this.props
    const { helpCenter, treeData, articleCollections, articles } = this.state
    const { dragIds, dragNodes, parentId, parentNode, index } = data

    if (dragNodes.length === 0) return;

    const droppedNode = parentNode
    const draggedNode = dragNodes[0]
    const draggedNodeData = draggedNode.data;

    if (draggedNodeData.type === HelpCenterTreeModelType.COLLECTION && droppedNode?.level >= 2) {
      alert(t('HelpCenter::Maximum level reached: this collection cannot have more than 3 levels'))
      return
    }

    // Dropped on root level
    if (droppedNode === null) {
      // Articles cannot be moved to root level
      if (draggedNodeData.type === HelpCenterTreeModelType.ARTICLE) return

      if (draggedNodeData.type === HelpCenterTreeModelType.COLLECTION) {
        const rootItems = treeData.map(item => item.model)
        const newPosition = HelpCenterHelper.getNewPositionBasedOnIndex(rootItems, index)
        const collection = draggedNode.data.model as ArticleCollection

        const updatedCollection = {
          ...collection,
          position: newPosition,
          parent_id: null
        }

        const articleCollectionIndex = articleCollections.findIndex(a => a.id === collection.id)

        const updatedCollections = [...articleCollections]

        updatedCollections[articleCollectionIndex] = updatedCollection

        // Update local copy
        this.setState({ articleCollections: updatedCollections, treeData: this.getTreeData(updatedCollections, articles) })
        await ArticleCollectionsController.update(helpCenter.id, updatedCollection)
        await this.fetchHelpCenterView()
        return
      }
    }

    // Determine new parent id. (no need to worry about this being an article since we block drops for these type of scenario's)
    const articleCollectionId = droppedNode.data.model.id
    let newPosition = 0

    const draggedModel = draggedNode.data.model
    const droppedNodeChildren = droppedNode.children
    const droppedNodeChildrenModels = droppedNodeChildren.map(child => child.data.model)

    if (droppedNode?.children?.length === 0) {
      newPosition = HelpCenterHelper.getCreatePosition(droppedNodeChildrenModels)
    } else {
      newPosition = HelpCenterHelper.getNewPositionBasedOnIndex(droppedNodeChildrenModels, index)
    }

    if (draggedNode.data.type === HelpCenterTreeModelType.COLLECTION) {
      const updatedCollection = {
        ...draggedModel,
        position: newPosition,
        parent_id: articleCollectionId
      }

      const articleCollectionIndex = articleCollections.findIndex(a => a.id === updatedCollection.id)

      const updatedCollections = [...articleCollections]

      updatedCollections[articleCollectionIndex] = updatedCollection

      this.setState({
        articleCollections: updatedCollections,
        treeData: this.getTreeData(updatedCollections, articles)
      })

      await ArticleCollectionsController.update(helpCenter.id, updatedCollection)
    } else if (draggedNode.data.type === HelpCenterTreeModelType.ARTICLE) {

      const updatedArticle = {
        ...draggedModel,
        position: newPosition,
        collection_id: articleCollectionId
      }

      const articleIndex = articles.findIndex(a => a.id === updatedArticle.id)

      const updatedArticles = [...articles]

      updatedArticles[articleIndex] = updatedArticle

      this.setState({ articles: updatedArticles, treeData: this.getTreeData(articleCollections, updatedArticles) })
      await ArticlesController.update(helpCenter.id, updatedArticle)
    }

    await this.fetchHelpCenterView()
  }

  onItemClick(node: HelpCenterTreeData) {
    const { helpCenter, selectedLocale } = this.state

    switch (node.type) {
      case HelpCenterTreeModelType.COLLECTION:
        requestAnimationFrame(() => {
          this.props.showArticleCollectionModal({
            helpCenterId: helpCenter.id,
            articleCollection: { id: node.model.id },
            locale: selectedLocale,
            onSubmit: this.onArticleCollectionSubmit
          })
        })
        break
      case HelpCenterTreeModelType.ARTICLE:
        requestAnimationFrame(() => {
          this.props.showArticleModal({
            helpCenterId: helpCenter.id,
            article: { id: node.model.id },
            locale: selectedLocale,
            onSubmit: this.onArticleSubmit,
            onDelete: this.onArticleDelete
          })
        })
        break
    }
  }

  onItemAddArticleClick(node: HelpCenterTreeData) {
    const { currentUser } = this.props
    const { helpCenter, selectedLocale } = this.state

    if (node.type !== HelpCenterTreeModelType.COLLECTION) {
      console.error('Invalid node type for adding article')
      return
    }


    requestAnimationFrame(() => {
      this.props.showArticleModal({
        helpCenterId: helpCenter.id,
        article: {
          collection_id: node.model.id,
          author_id: currentUser.id,
          position: HelpCenterHelper.getCreatePosition(node?.children?.map(child => child.model) || []),
        },
        locale: selectedLocale,
        onSubmit: this.onArticleSubmit,
        onDelete: this.onArticleDelete
      })
    })
  }

  onArticleSubmit(article: Article) {
    const { articles, articleCollections } = this.state

    const index = articles.findIndex(a => a.id === article.id)

    if (index !== -1) {
      articles[index] = article

      this.setState({
        articles: [...articles],
        treeData: this.getTreeData(articleCollections, articles)
      }, this.fetchHelpCenterView)
    } else {
      const updatedArticles = [...articles, article]

      this.setState({
        articles: updatedArticles,
        treeData: this.getTreeData(articleCollections, updatedArticles)
      }, this.fetchHelpCenterView)
    }
  }

  onArticleDelete(article: Article) {
    const { articleCollections, articles } = this.state

    const updatedArticles = articles.filter(a => a.id !== article.id)

    this.setState({
      articles: updatedArticles,
      treeData: this.getTreeData(articleCollections, updatedArticles)
    }, this.fetchHelpCenterView)
  }

  onItemAddCollectionClick(node: HelpCenterTreeData) {
    const { helpCenter, selectedLocale } = this.state

    if (node.type !== HelpCenterTreeModelType.COLLECTION) {
      console.error('Invalid node type for adding article')
      return
    }

    this.props.showArticleCollectionModal({
      helpCenterId: helpCenter.id,
      articleCollection: {
        parent_id: node.model.id,
        position: HelpCenterHelper.getCreatePosition(node?.children?.map(child => child.model) || []),
      },
      locale: selectedLocale,
      onSubmit: this.onArticleCollectionSubmit
    })
  }

  onArticleCollectionSubmit(articleCollection: ArticleCollection) {
    const { articles, articleCollections } = this.state

    const index = articleCollections.findIndex(a => a.id === articleCollection.id)

    if (index !== -1) {
      articleCollections[index] = articleCollection

      this.setState({
        articleCollections: [...articleCollections],
        treeData: this.getTreeData(articleCollections, articles)
      }, this.fetchHelpCenterView)
    } else {
      const updatedarticleCollections = [...articleCollections, articleCollection]

      this.setState({
        articleCollections: updatedarticleCollections,
        treeData: this.getTreeData(updatedarticleCollections, articles)
      }, this.fetchHelpCenterView)
    }
  }

  onItemEditClick(node: HelpCenterTreeData) {
    this.onItemClick(node)
  }

  onItemDeleteClick(node: HelpCenterTreeData) {
    const { t, showConfirmModal } = this.props
    const { helpCenter, articleCollections, articles } = this.state

    switch (node.type) {
      case HelpCenterTreeModelType.ARTICLE:
        showConfirmModal({
          title: t('HelpCenter::Delete article'),
          description: t('HelpCenter::You are about to delete this article. Are you sure?'),
          action: { label: t('HelpCenter::Delete'), isDestructive: true },
          onConfirm: async () => {
            try {
              await ArticlesController.delete(helpCenter.id, node.model.id)

              const updatedArticles = articles.filter(article => article.id !== node.model.id)

              this.setState({
                articles: updatedArticles,
                treeData: this.getTreeData(articleCollections, updatedArticles)
              }, this.fetchHelpCenterView)
            } catch (ex) {
              console.error(ex)
            }
          }
        })
        break
      case HelpCenterTreeModelType.COLLECTION:
        showConfirmModal({
          title: t('HelpCenter::Delete collection'),
          description: t('HelpCenter::You are about to delete this collection. By deleting this collection you are also deleting all its child collections and articles. Are you sure?'),
          action: { label: t('HelpCenter::Delete'), isDestructive: true },
          onConfirm: async () => {
            try {
              await ArticleCollectionsController.delete(helpCenter.id, node.model.id)

              const updatedArticleCollections = articleCollections.filter(articleCollection => articleCollection.id !== node.model.id)

              this.setState({
                articleCollections: updatedArticleCollections,
                treeData: this.getTreeData(updatedArticleCollections, articles)
              }, this.fetchHelpCenterView)
            } catch (ex) {
              console.error(ex)
            }
          }
        })
        break
    }
  }

  async onItemIconClick(node: HelpCenterTreeData, iconUrl: string) {
    if (!(node.type === HelpCenterTreeModelType.COLLECTION)) return

    const { model: articleCollection } = node

    const { helpCenter, articleCollections, articles } = this.state

    const updatedCollection = {
      ...articleCollection,
      icon: iconUrl
    }

    const articleCollectionIndex = articleCollections.findIndex(a => a.id === updatedCollection.id)

    const updatedCollections = [...articleCollections]

    updatedCollections[articleCollectionIndex] = updatedCollection

    ArticleCollectionsController.update(helpCenter.id, updatedCollection).catch(console.error)

    this.setState({
      articleCollections: updatedCollections,
      treeData: this.getTreeData(updatedCollections, this.state.articles)
    })
  }

  disableDrop(data: {
    parentNode: NodeApi<HelpCenterTreeData>;
    dragNodes: NodeApi<HelpCenterTreeData>[];
    index: number;
  }) {
    const droppedNode = data.parentNode
    const droppedNodeData = droppedNode.data
    const draggedNode = data.dragNodes[0]

    if (
      // Prevent moving an article to the root level
      (draggedNode?.data?.type === HelpCenterTreeModelType.ARTICLE && droppedNode?.level === -1) ||
      // Prevent moving a collection or article 3 levels deep
      droppedNode.level >= 3 ||
      // Prevent moving items under an article (visually)
      droppedNodeData.type === HelpCenterTreeModelType.ARTICLE
    ) return true

    return false
  }

  onSubviewModeChange(subviewMode: HelpCenterSubviewMode) {
    this.setState({ subviewMode: subviewMode })
  }

  onHelpCenterCopyUrlClick() {
    const { t } = this.props

    copy(this.getPreviewUrl())
    Notification.notifySuccess(t('HelpCenter::Copied to clipboard'))
  }

  onDefaultLocaleChange(option) {
    const { helpCenter } = this.state

    const updatedHelpCenter: HelpCenterType = {
      ...helpCenter,
      locale: option.value,
    }

    this.setState({ helpCenter: updatedHelpCenter }, () => {
      this.updateHelpCenter(updatedHelpCenter)
    })
  }

  onSupportedLocalesChange(options) {
    const { helpCenter } = this.state

    const updatedHelpCenter: HelpCenterType = {
      ...helpCenter,
      supported_locales: options ? options.map(option => option.value) : [],
    }

    this.setState({ helpCenter: updatedHelpCenter }, () => {
      this.updateHelpCenter(updatedHelpCenter)
    })
  }

  onSlugChange(e: React.ChangeEvent<HTMLInputElement>) {
    const { helpCenter } = this.state
    const updatedHelpCenter: HelpCenterType = {
      ...helpCenter,
      slug: e.target.value,
    }

    this.setState({ helpCenter: updatedHelpCenter }, () => {
      this.updateHelpCenterDebounced(updatedHelpCenter)
    })
  }

  onCustomDomainChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { helpCenter } = this.state
    const updatedHelpCenter: HelpCenterType = {
      ...helpCenter,
      custom_domain: e.target.value,
    }

    this.setState({ helpCenter: updatedHelpCenter }, () => {
      this.updateHelpCenterDebounced(updatedHelpCenter)
    })
  }

  onGoogleAnalyticsTrackingIdChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { helpCenter } = this.state
    const updatedHelpCenter: HelpCenterType = {
      ...helpCenter,
      google_analytics_id: e.target.value,
    }

    this.setState({ helpCenter: updatedHelpCenter }, () => {
      this.updateHelpCenterDebounced(updatedHelpCenter)
    })
  }

  onFaviconChange(blob: Blob | null) {
    const { helpCenter } = this.state

    const updatedHelpCenter: HelpCenterType = {
      ...helpCenter,
      favicon: blob?.signed_id || null,
    }

    this.setState({ helpCenter: updatedHelpCenter }, () => {
      this.updateHelpCenterDebounced(updatedHelpCenter)
    })
  }

  onOpenGraphImageChange(blob: Blob | null) {
    const { helpCenter } = this.state

    const updatedHelpCenter: HelpCenterType = {
      ...helpCenter,
      open_graph_image: blob?.signed_id || null,
    }

    this.setState({ helpCenter: updatedHelpCenter }, () => {
      this.updateHelpCenterDebounced(updatedHelpCenter)
    })
  }

  onFeaturedArticlesTitleChange(e: React.ChangeEvent<HTMLInputElement>) {
    const { helpCenter, editLocale } = this.state
    const updatedHelpCenter: HelpCenterType = {
      ...helpCenter,
      translations: MobilityHelper.updateTranslation(editLocale, helpCenter.translations, 'featured_articles_title', e.currentTarget.value),
    }
    this.setState({ helpCenter: updatedHelpCenter }, () => {
      this.updateHelpCenterDebounced(updatedHelpCenter)
    })
  }

  onFeaturedArticlesDragEnd(dropResult: DropResult, provided: ResponderProvided) {
    const { helpCenter, featuredArticles } = this.state
    const { destination, source } = dropResult

    // If there's no destination (dropped outside), do nothing
    if (!destination) {
      return
    }

    // If the item was dropped in the same position, do nothing
    // did not move anywhere - can bail early
    if (
      source.droppableId === destination.droppableId &&
      source.index === destination.index
    ) {
      return;
    }

    const movedFeaturedArticle = featuredArticles[source.index]
    const movedFeatureArticleId = movedFeaturedArticle.id

    // Calculate the new task position based on the tasks inside the list
    const newFeaturedArticlePosition = DroppableHelper.getNewPositionBasedOnDropResult(featuredArticles, dropResult)

    //
    const featuredArticleIndex = featuredArticles.findIndex(featuredArtice => featuredArtice.id === movedFeatureArticleId)

    if (featuredArticleIndex !== -1) {
      featuredArticles[featuredArticleIndex].position = newFeaturedArticlePosition

      const updatedFeaturedArticle: FeaturedArticle = featuredArticles[featuredArticleIndex]

      FeaturedArticlesController.update(helpCenter.id, updatedFeaturedArticle).catch(console.error)

      this.setState({ featuredArticles: [...featuredArticles].sort((a, b) => a.position - b.position) })
    }
  }

  onRemoveFeaturedArticleClick(featuredArticle: FeaturedArticle) {
    const { helpCenter, featuredArticles } = this.state

    const updatedFeaturedArticles = featuredArticles.filter(a => a.id !== featuredArticle.id)

    this.setState({ featuredArticles: updatedFeaturedArticles }, () => {
      FeaturedArticlesController.delete(helpCenter.id, featuredArticle.id).catch(console.error)
    })
  }

  async onAddFeaturedArticle(option) {
    const { helpCenter, articles, featuredArticles } = this.state

    const article = articles.find(article => article.id === option.value)

    const featuredArticle: FeaturedArticle = {
      article_id: article.id,
      position: DroppableHelper.getCreatePosition(featuredArticles)
    }

    try {
      const responseFeaturedArticle = await FeaturedArticlesController.create(helpCenter.id, featuredArticle)

      this.setState({
        featuredArticles: [
          ...featuredArticles,
          responseFeaturedArticle
        ]
      })
    } catch (ex) {
      console.error(ex)
    }
  }

  onBackgroundColorChange(color: string) {
    const { helpCenter } = this.state
    const updatedHelpCenter: HelpCenterType = {
      ...helpCenter,
      background_color: color,
    }
    this.setState({ helpCenter: updatedHelpCenter }, () => {
      this.updateHelpCenterDebounced(updatedHelpCenter)
    })
  }

  onActionColorChange(color: string) {
    const { helpCenter } = this.state
    const updatedHelpCenter: HelpCenterType = {
      ...helpCenter,
      action_color: color,
    }
    this.setState({ helpCenter: updatedHelpCenter }, () => {
      this.updateHelpCenterDebounced(updatedHelpCenter)
    })
  }

  onShowArticleAuthorsChange() {
    const { helpCenter } = this.state

    const updatedHelpCenter: HelpCenterType = {
      ...helpCenter,
      show_article_authors: !helpCenter.show_article_authors,
    }

    this.setState({ helpCenter: updatedHelpCenter }, () => {
      this.updateHelpCenterDebounced(updatedHelpCenter)
    })
  }

  onHelpCenterSettingLocaleChange(option) {
    this.setState({ editLocale: option.value })
  }

  onLogoChange(blob: Blob | null) {
    const { helpCenter } = this.state

    const updatedHelpCenter: HelpCenterType = {
      ...helpCenter,
      logo: blob?.signed_id || null,
    }

    this.setState({ helpCenter: updatedHelpCenter }, () => {
      this.updateHelpCenterDebounced(updatedHelpCenter)
    })
  }

  onHeaderPageTitleChange(e: React.ChangeEvent<HTMLInputElement>) {
    const { helpCenter } = this.state
    const updatedHelpCenter: HelpCenterType = {
      ...helpCenter,
      header_page_title: e.target.value,
    }
    this.setState({ helpCenter: updatedHelpCenter }, () => {
      this.updateHelpCenterDebounced(updatedHelpCenter)
    })
  }

  onHeaderLinksChange(links: HelpCenterLink[]) {
    const { helpCenter } = this.state
    const updatedHelpCenter: HelpCenterType = {
      ...helpCenter,
      header_links: links,
    }

    this.setState({ helpCenter: updatedHelpCenter }, () => {
      this.updateHelpCenterDebounced(updatedHelpCenter)
    })
  }

  onHeaderBackgroundColorChange(color: string) {
    const { helpCenter } = this.state
    const updatedHelpCenter: HelpCenterType = {
      ...helpCenter,
      header_background_color: color,
    }
    this.setState({ helpCenter: updatedHelpCenter }, () => {
      this.updateHelpCenterDebounced(updatedHelpCenter)
    })
  }

  onHeaderTextColorChange(color: string) {
    const { helpCenter } = this.state
    const updatedHelpCenter: HelpCenterType = {
      ...helpCenter,
      header_text_color: color,
    }
    this.setState({ helpCenter: updatedHelpCenter }, () => {
      this.updateHelpCenterDebounced(updatedHelpCenter)
    })
  }

  onWelcomeMessageChange(e) {
    const { helpCenter, editLocale } = this.state

    const updatedHelpCenter: HelpCenterType = {
      ...helpCenter,
      translations: MobilityHelper.updateTranslation(editLocale, helpCenter.translations, 'welcome_message', e.currentTarget.value),
    }

    this.setState({ helpCenter: updatedHelpCenter }, () => {
      this.updateHelpCenterDebounced(updatedHelpCenter)
    })
  }

  onHeroImageChange(blob: Blob | null) {
    const { helpCenter } = this.state
    const updatedHelpCenter: HelpCenterType = {
      ...helpCenter,
      header_image: blob?.signed_id || null,
    }

    this.setState({ helpCenter: updatedHelpCenter }, () => {
      this.updateHelpCenterDebounced(updatedHelpCenter)
    })
  }

  onHeroBackgroundFadeChange() {
    const { helpCenter } = this.state

    const updatedHelpCenter: HelpCenterType = {
      ...helpCenter,
      header_background_fade: !helpCenter.header_background_fade,
    }

    this.setState({ helpCenter: updatedHelpCenter }, () => {
      this.updateHelpCenterDebounced(updatedHelpCenter)
    })
  }

  onHeroHeightChange(e: React.ChangeEvent<HTMLInputElement>) {
    const { helpCenter } = this.state
    const updatedHelpCenter: HelpCenterType = {
      ...helpCenter,
      header_height: parseInt(e.target.value, 10) || 0,
    }
    this.setState({ helpCenter: updatedHelpCenter }, () => {
      this.updateHelpCenterDebounced(updatedHelpCenter)
    })
  }

  onCollectionDescriptionsEnabledChange() {
    const { helpCenter } = this.state

    const updatedHelpCenter: HelpCenterType = {
      ...helpCenter,
      collection_descriptions_enabled: !helpCenter.collection_descriptions_enabled,
    }

    this.setState({ helpCenter: updatedHelpCenter }, () => {
      this.updateHelpCenterDebounced(updatedHelpCenter)
    })
  }

  onTableOfContentsEnabledChange() {
    const { helpCenter } = this.state

    const updatedHelpCenter: HelpCenterType = {
      ...helpCenter,
      table_of_contents_enabled: !helpCenter.table_of_contents_enabled,
    }

    this.setState({ helpCenter: updatedHelpCenter }, () => {
      this.updateHelpCenterDebounced(updatedHelpCenter)
    })
  }

  onRelatedArticlesEnabledChange() {
    const { helpCenter } = this.state
    const updatedHelpCenter: HelpCenterType = {
      ...helpCenter,
      related_articles_enabled: !helpCenter.related_articles_enabled,
    }
    this.setState({ helpCenter: updatedHelpCenter }, () => {
      this.updateHelpCenterDebounced(updatedHelpCenter)
    })
  }

  renderGeneralSettings() {
    const { t } = this.props
    const { helpCenter, didInitialLoad, editLocale, articles, featuredArticles } = this.state

    const availableLocaleOptions = HelpCenterHelper.getAvailableLocaleOptions()
    const defaultLocaleOption = availableLocaleOptions.find(option => option.value === helpCenter.locale)

    const additionalLocaleOptions = availableLocaleOptions.filter(option => option.value !== helpCenter.locale)
    const selectedLocaleOptions = additionalLocaleOptions.filter(option => helpCenter.supported_locales.includes(option.value as PublicLocale))

    const supportedLocaleOptions = HelpCenterHelper.getSupportedLocaleOptions(helpCenter)
    const selectedLocaleOption = supportedLocaleOptions.find(option => option.value === String(editLocale))

    const featuredArticleIds = featuredArticles.map(featuredArticle => featuredArticle.article_id)
    const articleOptions = articles
      // Filter out featured articles from the list of available articles
      .filter(article => !featuredArticleIds.includes(article.id))
      .map(article => ({
        label: MobilityHelper.getTranslation(editLocale, article.translations, 'title') || t('HelpCenter::Untitled'),
        value: article.id,
      }))


    return (
      <AccordionContainer>
        <Accordion title={t('HelpCenter::Supported languages')}>
          <div className='form-item'>
            <label>{t('HelpCenter::Default language')}</label>
            <PowerSelect
              options={availableLocaleOptions}
              value={defaultLocaleOption}
              onChange={this.onDefaultLocaleChange}
              placeholder={t('HelpCenter::Select default language')}
            />
          </div>

          <div className='form-item'>
            <label>{t('HelpCenter::Additional languages')}</label>
            <PowerSelect
              options={additionalLocaleOptions}
              value={selectedLocaleOptions}
              onChange={this.onSupportedLocalesChange}
              placeholder={t('HelpCenter::Select additional languages')}
              // @ts-ignore
              isMulti={true}
            />
          </div>
        </Accordion>

        <Accordion title={t('HelpCenter::Domains')}>
          <div className='form-item'>
            <label>{t('HelpCenter::Slug')}</label>
            <input
              type='text'
              value={helpCenter.slug}
              onChange={this.onSlugChange}
            />
          </div>
          <div className='form-item'>
            <label>{t('HelpCenter::Custom help center domain')}</label>
            <input
              type='text'
              value={helpCenter.custom_domain || ''}
              onChange={this.onCustomDomainChange}
              placeholder={t('HelpCenter::e.g. docs.example.com')}
            />
          </div>
        </Accordion>

        <Accordion title={t('HelpCenter::Analytics')}>
          <div className='form-item'>
            <label>{t('HelpCenter::Google analytics tracking ID')}</label>
            <input
              type='text'
              value={helpCenter.google_analytics_id || ''}
              onChange={this.onGoogleAnalyticsTrackingIdChange}
              placeholder='UA-XXXXXXXXX-X'
            />
          </div>
        </Accordion>

        <Accordion title={t('HelpCenter::Social media images')}>
          <div className='form-item'>
            <label>
              {t('HelpCenter::Favicon')}
              <Tooltip
                content={t('HelpCenter::Recommended ratio: 1:1. 150KB max. This icon appears before the title on your customers\' browser tab.')}
                containerStyle={{ marginLeft: 8 }}
              />
            </label>

            <FaviconUpload
              url={helpCenter.favicon_url}
              onSubmit={this.onFaviconChange}
            />
          </div>

          <div className='form-item'>
            <label>
              {t('HelpCenter::Social media image')}
              <Tooltip
                content={t('HelpCenter::Recommended: 5:2 ratio, 2MB size. This is the image that appears when your Help Center is shared on Facebook, Twitter or any other social media. Recommended: 1.91:1 ratio, 2MB size, 1200 x 630 dimensions')}
                containerStyle={{ marginLeft: 8 }}
              />
            </label>

            <AttachmentUploader
              url={helpCenter.open_graph_image_url}
              onSubmit={this.onOpenGraphImageChange}
              maxSize={HELPCENTER_OPEN_GRAPH_IMAGE_FILE_SIZE}
              accept={[
                MimeTypes.PNG,
                MimeTypes.JPEG,
                MimeTypes.JPG,
                MimeTypes.WEBP
              ]}
            />
          </div>
        </Accordion>

        <Accordion title={t('HelpCenter::Featured articles')}>
          <div className='form-item'>
            <PowerSelect
              options={supportedLocaleOptions}
              value={selectedLocaleOption}
              onChange={this.onHelpCenterSettingLocaleChange}
              placeholder={t('HelpCenter::Select edit language')}
            />
          </div>

          <div className='form-item'>
            <label>
              {t('HelpCenter::Title')}
              <Tooltip
                content={t('HelpCenter::The title of the featured articles section on the homepage.')}
                containerStyle={{ marginLeft: 8 }}
              />
            </label>
            <input
              type='text'
              value={MobilityHelper.getTranslation(editLocale, helpCenter.translations, 'featured_articles_title')}
              onChange={this.onFeaturedArticlesTitleChange}
              placeholder={t('HelpCenter::e.g. Featured Articles, Popular Articles, Top Help Center Articles')}
            />
          </div>
          <div className='form-item'>
            <label>
              {t('HelpCenter::Featured articles')}
              <Tooltip
                content={t('HelpCenter::Featured articles are displayed on the homepage of your Help Center.')}
                containerStyle={{ marginLeft: 8 }}
              />
            </label>

            <div style={{ marginBottom: 16 }}>
              <PowerSelect
                options={articleOptions}
                onChange={this.onAddFeaturedArticle}
                value={null}
                placeholder={t('HelpCenter::Select an article to feature')}
              />
            </div>

            <FeaturedArticlesContainer>
              <FeaturedArticlesHeader>
                <div style={{ width: 16 }} />
                <FeaturedArticlesHeaderLabel>{t('HelpCenter::Title')}</FeaturedArticlesHeaderLabel>
                <div style={{ width: 8 }} />
              </FeaturedArticlesHeader>

              <DragDropContext onDragEnd={this.onFeaturedArticlesDragEnd}>
                <Droppable droppableId='featured-articles'>
                  {(provided) => {

                    return (
                      <>
                        <FeaturedArticles ref={provided.innerRef} {...provided.droppableProps}>
                          {featuredArticles.map((featuredArticle, index) => {
                            const title = MobilityHelper.getTranslation(editLocale, featuredArticle.article.translations, 'title')

                            return (
                              <Draggable key={featuredArticle.id} draggableId={String(featuredArticle.id)} index={index}>
                                {(provided) => {
                                  return (
                                    <>

                                      <FeaturedArticleContainer ref={provided.innerRef} {...provided.draggableProps}>
                                        <FeaturedArticleHandle {...provided.dragHandleProps}>
                                          <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M13 9C12.17 9 11.5 9.67 11.5 10.5C11.5 11.33 12.17 12 13 12C13.83 12 14.5 11.33 14.5 10.5C14.5 9.67 13.83 9 13 9ZM3 9C2.17 9 1.5 9.67 1.5 10.5C1.5 11.33 2.17 12 3 12C3.83 12 4.5 11.33 4.5 10.5C4.5 9.67 3.83 9 3 9ZM8 9C7.17 9 6.5 9.67 6.5 10.5C6.5 11.33 7.17 12 8 12C8.83 12 9.5 11.33 9.5 10.5C9.5 9.67 8.83 9 8 9ZM13 7C13.83 7 14.5 6.33 14.5 5.5C14.5 4.67 13.83 4 13 4C12.17 4 11.5 4.67 11.5 5.5C11.5 6.33 12.17 7 13 7ZM3 4C2.17 4 1.5 4.67 1.5 5.5C1.5 6.33 2.17 7 3 7C3.83 7 4.5 6.33 4.5 5.5C4.5 4.67 3.83 4 3 4ZM8 4C7.17 4 6.5 4.67 6.5 5.5C6.5 6.33 7.17 7 8 7C8.83 7 9.5 6.33 9.5 5.5C9.5 4.67 8.83 4 8 4Z"></path></svg>
                                        </FeaturedArticleHandle>
                                        <FeaturedArticlesHeaderLabel>
                                          <input
                                            type='text'
                                            placeholder={t('HelpCenter::Label')}
                                            value={title}
                                            disabled
                                          />
                                        </FeaturedArticlesHeaderLabel>
                                        <SimpleTooltip content={t('HelpCenter::Remove featured article')}>
                                          <FeaturedArticleRemove onClick={() => this.onRemoveFeaturedArticleClick(featuredArticle)}>
                                            <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M11.02 3L10.78 1.64999C10.61 0.689994 9.78 0 8.81 0H7.19C6.22 0 5.39 0.699994 5.22 1.64999L4.98 3H1V4.5H2.2L3.73 13.17C3.81 13.65 4.23 14 4.71 14H11.28C11.77 14 12.18 13.65 12.26 13.17L13.79 4.5H14.99V3H11.01H11.02ZM5.13 12.5L3.72 4.5H5.45L6.86 12.5H5.13ZM6.51 3L6.7 1.91C6.74 1.67 6.95 1.5 7.19 1.5H8.81C9.05 1.5 9.26 1.67 9.3 1.91L9.49 3H6.5H6.51Z"></path></svg>
                                          </FeaturedArticleRemove>
                                        </SimpleTooltip>
                                      </FeaturedArticleContainer>
                                    </>
                                  )
                                }}
                              </Draggable>
                            )
                          })}
                          {provided.placeholder}
                        </FeaturedArticles>
                      </>
                    )
                  }}
                </Droppable>
              </DragDropContext>
            </FeaturedArticlesContainer>
          </div>
        </Accordion>
      </AccordionContainer >
    )
  }

  renderStylingSettings() {
    const { t } = this.props
    const { helpCenter, editLocale } = this.state

    const supportedLocaleOptions = HelpCenterHelper.getSupportedLocaleOptions(helpCenter)
    const selectedLocaleOption = supportedLocaleOptions.find(option => option.value === String(editLocale))

    return (
      <AccordionContainer>
        <Accordion title={t('HelpCenter::Shared elements')}>
          <div className='form-item'>
            <label>{t('HelpCenter::Body background color')}</label>
            <p style={{ marginBottom: 8 }}>{t('HelpCenter::Applies to the background of all pages')}</p>
            <SwatchPickerContainer>
              <SwatchPicker
                color={helpCenter.background_color}
                onChange={this.onBackgroundColorChange}
              />
            </SwatchPickerContainer>
          </div>
          <div className='form-item'>
            <label>{t('HelpCenter::Action color')}</label>
            <p style={{ marginBottom: 8 }}>{t('HelpCenter::Used in buttons, links and other elements. Color will not update for icons uploaded in JPEG/PNG/GIF format.')}</p>
            <SwatchPickerContainer>
              <SwatchPicker
                color={helpCenter.action_color}
                onChange={this.onActionColorChange}
              />
            </SwatchPickerContainer>
          </div>
          <div className='form-item'>
            <label>
              {t('HelpCenter::Show article authors')}

              <Tooltip
                content={t('HelpCenter::Recommended: 5:1 ratio, 1MB size.')}
                containerStyle={{ marginLeft: 8 }}
              />
            </label>
            <p style={{ marginBottom: 8 }}>{t('HelpCenter::Author avatars make your Help Center more personal')}</p>
            <div style={{ width: 'fit-content' }}>
              <CheckboxInput
                checked={helpCenter.show_article_authors}
                onChange={this.onShowArticleAuthorsChange}
                label={t('HelpCenter::Show article authors')}
              />
            </div>
          </div>
        </Accordion>

        <Accordion title={t('HelpCenter::Header')}>
          <div className='form-item'>
            <PowerSelect
              options={supportedLocaleOptions}
              value={selectedLocaleOption}
              onChange={this.onHelpCenterSettingLocaleChange}
              placeholder={t('HelpCenter::Select edit language')}
            />
          </div>

          <div className='form-item'>
            <label>
              {t('HelpCenter::Logo')}
              <Tooltip
                content={t('HelpCenter::Recommended: 5:1 ratio, 1MB size.')}
                containerStyle={{ marginLeft: 8 }}
              />
            </label>
            <AttachmentUploader
              url={helpCenter.logo_url}
              onSubmit={this.onLogoChange}
              maxSize={HELPCENTER_LOGO_FILE_SIZE}
              accept={[
                MimeTypes.PNG,
                MimeTypes.SVG,
                MimeTypes.JPEG,
                MimeTypes.JPG,
                MimeTypes.WEBP
              ]}
            />
          </div>

          <div className='form-item'>
            <label>
              {t('HelpCenter::Page title')}
              <Tooltip
                content={t('HelpCenter::The page title will appear in the top left corner of your Help Center unless a logo is specified.')}
                containerStyle={{ marginLeft: 8 }}
              />
            </label>
            <input
              type='text'
              value={helpCenter.header_page_title}
              onChange={this.onHeaderPageTitleChange}
              placeholder={t('HelpCenter::e.g. Help Center, Support Center')}
            />
          </div>

          <div className='form-item'>
            <label>
              {t('HelpCenter::Header links')}
              <Tooltip
                content={t('HelpCenter::You can add up to 3 links in the header, which will appear in the top right corner of your Help Center.')}
                containerStyle={{ marginLeft: 8 }}
              />
            </label>

            <div style={{ marginBottom: 8 }}>
              <LinksBuilder
                locale={editLocale}
                links={helpCenter.header_links}
                onChange={this.onHeaderLinksChange}
              />
            </div>
          </div>

          <div className='form-item'>
            <label>{t('HelpCenter::Welcome message')}</label>
            <input
              type='text'
              value={MobilityHelper.getTranslation(editLocale, helpCenter.translations, 'welcome_message')}
              onChange={this.onWelcomeMessageChange}
              placeholder={t('HelpCenter::e.g. Welcome to our Help Center! How can we assist you today?')}
            />
          </div>

          <div className='form-item'>
            <label>{t('HelpCenter::Background color')}</label>
            <SwatchPickerContainer>
              <SwatchPicker
                color={helpCenter.header_background_color}
                onChange={this.onHeaderBackgroundColorChange}
              />
            </SwatchPickerContainer>
          </div>

          <div className='form-item'>
            <label>{t('HelpCenter::Text color')}</label>
            <SwatchPickerContainer>
              <SwatchPicker
                color={helpCenter.header_text_color}
                onChange={this.onHeaderTextColorChange}
              />
            </SwatchPickerContainer>
          </div>

          <div className='form-item'>
            <label>{t('HelpCenter::Header image')}</label>
            <AttachmentUploader
              url={helpCenter.header_image_url}
              onSubmit={this.onHeroImageChange}
              maxSize={HELP_CENTER_HERO_IMAGE_FILE_SIZE}
              accept={[
                MimeTypes.PNG,
                MimeTypes.JPEG,
                MimeTypes.JPG,
                MimeTypes.WEBP
              ]}
            />
          </div>

          <div className='form-item'>
            <div style={{ width: 'fit-content' }}>
              <CheckboxInput
                checked={helpCenter.header_background_fade}
                onChange={this.onHeroBackgroundFadeChange}
                label={t('HelpCenter::Fade background')}
              />
            </div>
          </div>

          <div className='form-item'>
            <label>{t('HelpCenter::Height')}</label>
            <input
              type='number'
              value={helpCenter.header_height}
              onChange={this.onHeroHeightChange}
              style={{ maxWidth: 100 }}
            />
          </div>
        </Accordion>

        <Accordion title={t('HelpCenter::Collection page')}>
          <div className='form-item'>
            <label>{t('HelpCenter::Content descriptions')}</label>
            <p style={{ marginBottom: 8 }}>{t('HelpCenter::Show or hide descriptions on the Collections page. Hiding descriptions makes it easier to scan through your articles.')}</p>
            <div style={{ width: 'fit-content' }}>
              <CheckboxInput
                checked={helpCenter.collection_descriptions_enabled}
                onChange={this.onCollectionDescriptionsEnabledChange}
                label={t('HelpCenter::Show descriptions')}
              />
            </div>
          </div>
        </Accordion>

        <Accordion title={t('HelpCenter::Article page')}>
          <div className='form-item'>
            <label>{t('HelpCenter::Table of contents')}</label>
            <p style={{ marginBottom: 8 }}>{t('HelpCenter::Table of contents is automatically generated from H1 and H2 headings in your articles. It is available in your Help Center on the web and in the Messenger.')}</p>
            <div style={{ width: 'fit-content' }}>
              <CheckboxInput
                checked={helpCenter.table_of_contents_enabled}
                onChange={this.onTableOfContentsEnabledChange}
                label={t('HelpCenter::Show table of contents')}
              />
            </div>
          </div>

          <div className='form-item'>
            <label>{t('HelpCenter::Related articles')}</label>
            <p style={{ marginBottom: 8 }}>{t('HelpCenter::Related articles displays up to 5 suggested articles at the end of the article. Article suggestions are based on associated article tags. If there are no related articles, this section will not be shown.')}</p>
            <div style={{ width: 'fit-content' }}>
              <CheckboxInput
                checked={helpCenter.related_articles_enabled}
                onChange={this.onRelatedArticlesEnabledChange}
                label={t('HelpCenter::Show related articles')}
              />
            </div>
          </div>
        </Accordion>
      </AccordionContainer>
    )
  }

  getPreviewUrl() {
    const { helpCenter, selectedLocale, selectedPage, articles, articleCollections } = this.state

    if (!helpCenter) return ''

    let path = ''

    switch (selectedPage) {
      case HelpCenterPage.ARTICLE:
        if (articles.length > 0) path = `articles/${articles[0].id}-${MobilityHelper.getTranslation(selectedLocale, articles[0].translations, 'slug')}`
        break
      case HelpCenterPage.COLLECTION:
        if (articleCollections.length > 0) path = `collections/${articleCollections[0].id}-${MobilityHelper.getTranslation(selectedLocale, articleCollections[0].translations, 'slug')}`
        break
    }

    if (path?.length === 0) {
      return [helpCenter.url, selectedLocale].join('/')
    } else {
      return [helpCenter.url, selectedLocale, path].join('/')
    }
  }

  render() {
    const { t, currentUser } = this.props
    const {
      viewMode,
      subviewMode,
      helpCenter,
      didInitialLoad,
      selectedLocale,
      selectedPage,
      browserSize,
      treeData,
    } = this.state

    const supportedLocaleOptions = HelpCenterHelper.getSupportedLocaleOptions(helpCenter)
    const selectedLocaleOption = supportedLocaleOptions.find(option => option.value === String(selectedLocale))

    const pageOptions = Object.keys(HelpCenterPage).map(key => {
      return { label: t(`HelpCenterPage::${HelpCenterPage[key]}`), value: HelpCenterPage[key] }
    })
    const selectedPageOption = pageOptions.find(option => option.value === String(selectedPage))

    const browserSizeOptions = Object.keys(BrowserSize).map(key => (
      { label: t(`BrowserSize::${BrowserSize[key]}`), value: BrowserSize[key] }
    ))
    const selectedBrowserSizeOption = browserSizeOptions.find(option => option.value === browserSize)

    return (
      <>
        <Helmet>
          <title>{t('HelpCenter::{{__appName}} | Help center')}</title>
        </Helmet>

        <TopNavigation
          icon='book'
          title={t('HelpCenter::Help center')}
        />

        <ScrollToTopOnMount />

        {!didInitialLoad && <PageLoaderContainer><PageLoader /></PageLoaderContainer>}

        {didInitialLoad && <FullPageContent>
          <Container>
            <Content>
              {viewMode === HelpCenterViewMode.CONTENT && <>
                <Header>
                  <HeaderActions>
                    <PowerSelect
                      options={supportedLocaleOptions}
                      value={selectedLocaleOption}
                      styles={{
                        container: () => ({ width: '150px' }),
                        menu: (provided) => ({
                          ...provided,
                          width: 'auto',
                          minWidth: '150px'
                        })
                      }}
                      onChange={this.onSelectedLocaleChange}
                    />
                  </HeaderActions>

                  <HeaderActions>
                    <Button
                      type='default'
                      icon='plus'
                      text={t('HelpCenter::Add collection')}
                      onClick={this.onAddCollectionClick}
                    />
                  </HeaderActions>
                </Header>

                {treeData.length === 0 && <Card>
                  <CardEmptyInfo
                    icon='folder'
                    description={t('HelpCenter::No collections have been created yet')}
                  />
                </Card>}

                {treeData.length > 0 && <Table>
                  <TableHeader>
                    <TableHeading>
                      {t('HelpCenter::Name')}
                    </TableHeading>
                    <TableHeading>
                      {t('HelpCenter::Status')}
                    </TableHeading>
                    <TableHeading>
                      {t('HelpCenter::Articles')}
                    </TableHeading>
                    <TableActions />
                  </TableHeader>

                  <TableRows>
                    <ResizeObserver>
                      {({ width }) => {
                        return (
                          <Tree
                            data={treeData}
                            rowHeight={76.8}
                            width={width}
                            openByDefault={false}
                            idAccessor={(data) => `${data.type}-${data.model.id}`}
                            onMove={this.onItemMove}
                            disableDrop={this.disableDrop}
                            disableMultiSelection
                            indent={16}
                          >
                            {(props) => (
                              <Item
                                {...props}
                                helpcenterId={helpCenter.id}
                                locale={selectedLocale}
                                onClick={this.onItemClick}
                                onAddArticleClick={this.onItemAddArticleClick}
                                onAddCollectionClick={this.onItemAddCollectionClick}
                                onEditClick={this.onItemEditClick}
                                onDeleteClick={this.onItemDeleteClick}
                                onIconClick={this.onItemIconClick}
                              />
                            )}
                          </Tree>
                        )
                      }}
                    </ResizeObserver>
                  </TableRows>
                </Table>}
              </>}
              {viewMode === HelpCenterViewMode.SETTINGS && <>
                <Header>
                  <HeaderActions>
                    <Breadcrumb
                      content={t('HelpCenter::Back')}
                      url='javascript://'
                      onClick={this.onExitSettingsClick}
                    />
                  </HeaderActions>

                  <HeaderActions>
                    <ButtonGroup
                      items={[
                        { element: t('HelpCenter::General'), onClick: () => this.onSubviewModeChange(HelpCenterSubviewMode.GENERAL), active: subviewMode === HelpCenterSubviewMode.GENERAL },
                        { element: t('HelpCenter::Styling'), onClick: () => this.onSubviewModeChange(HelpCenterSubviewMode.STYLING), active: subviewMode === HelpCenterSubviewMode.STYLING }
                      ]}
                    />
                  </HeaderActions>
                </Header>

                {subviewMode === HelpCenterSubviewMode.GENERAL && this.renderGeneralSettings()}
                {subviewMode === HelpCenterSubviewMode.STYLING && this.renderStylingSettings()}
              </>}
            </Content>

            <Preview>
              <Header>
                <HeaderActions>
                  <PowerSelect
                    options={pageOptions}
                    value={selectedPageOption}
                    styles={{
                      container: () => ({ width: '150px' }),
                      menu: (provided) => ({
                        ...provided,
                        width: 'auto',
                        minWidth: '150px'
                      })
                    }}
                    onChange={this.onPageChange}
                  />
                </HeaderActions>

                <HeaderActions>
                  <SimpleTooltip content={t('HelpCenter::Help center settings')}>
                    <div>
                      <IconButton
                        icon='setting'
                        onClick={this.onSettingsClick}
                      />
                    </div>
                  </SimpleTooltip>

                  <PowerSelect
                    options={browserSizeOptions}
                    value={selectedBrowserSizeOption}
                    styles={{
                      container: () => ({ width: '150px' }),
                      menu: (provided) => ({
                        ...provided,
                        width: 'auto',
                        minWidth: '150px'
                      })
                    }}
                    onChange={this.onBrowserSizeChange}
                  />
                </HeaderActions>
              </Header>

              <BrowserPreview>
                <BrowserContainer size={browserSize}>
                  <Browser>
                    <BrowserHeader onClick={this.onHelpCenterCopyUrlClick}>
                      <BrowserUrl>
                        <span>{this.getPreviewUrl()}</span>
                      </BrowserUrl>
                    </BrowserHeader>

                    <ResizeObserver>
                      {({ width, height }) => {
                        let scale = 1;
                        let contentWidth = width;
                        let contentHeight = height;
                        let xOffset = 0;

                        if (browserSize === BrowserSize.DESKTOP) {
                          contentWidth = 1200;
                          scale = width / contentWidth;
                          contentHeight = height / scale;
                          xOffset = (width - contentWidth * scale) / 2;
                        } else if (browserSize === BrowserSize.TABLET) {
                          contentWidth = 768;
                          scale = width / contentWidth;
                          contentHeight = height / scale;
                          xOffset = (width - contentWidth * scale) / 2;
                        } else if (browserSize === BrowserSize.MOBILE) {
                          contentWidth = 375;
                          scale = width / contentWidth;
                          contentHeight = height / scale;
                          xOffset = (width - contentWidth * scale) / 2;
                        }
                        return (
                          <BrowserContentContainer
                            style={{
                              left: 1,
                              top: 40,
                              width: contentWidth,
                              height: contentHeight,
                              borderRadius: Style.variables.baseBorderRadius,
                              transform: `scale(${scale})`,
                              transformOrigin: 'top left',
                            }}
                          >
                            <BrowserContent src={this.getPreviewUrl()} />
                          </BrowserContentContainer>
                        )
                      }}
                    </ResizeObserver>

                  </Browser>
                </BrowserContainer>
              </BrowserPreview>
            </Preview>
          </Container>
        </FullPageContent>}
      </>
    )
  }
}

const mapStateToProps = (state: AppState): IStateToProps => {
  const {
    authentication: {
      currentUser,
    },
  } = state

  return {
    currentUser: currentUser,
  }
}

const mapDispatchToProps: IDispatchToProps = {
  showHelpCenterModal,
  showArticleCollectionModal,
  showArticleModal,
  showConfirmModal,
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(HelpCenter))